<template>
    <div class="page">
        <div class="page_content">
           <div class="top" data-aos="fade-down" data-aos-duration="500">
               <div class="top_title_text">{{text.title[lang]}}</div>
               <div class="downtext">{{text.downtext[lang]}}</div>
               <div class="icon_down">︾</div>
            </div>
            <div class="middle1">
                <div class="mid_textbox1" data-aos="fade-down" data-aos-duration="500" data-aos-delay="300">
                    <div class="mid_title">{{text.midpart1.title[lang]}}</div>
                    <div class="mid_content">{{text.midpart1.content[lang]}}</div>
                </div>
                <div class="mid_img1" data-aos="fade-down" data-aos-duration="500">
                    <img class="img_base" src="../assets/images/consumer_1.jpg" alt="">
                </div>
            </div>
            <div class="subtitle" data-aos="fade-down" data-aos-duration="500">{{text.subtitle[lang]}}</div>
            <div class="middle4">
                <div class="middle4_left middle4_item" data-aos="fade-down" data-aos-duration="500">
                    <div class="middle4_title">{{text.midpart3.left.title[lang]}}</div>
                    <div class="middle4_content">{{text.midpart3.left.content[lang]}}</div>
                </div>
                <div class="middle4_right middle4_item" data-aos="fade-down" data-aos-duration="500" data-aos-delay="300">
                    <div class="middle4_title">{{text.midpart3.right.title[lang]}}</div>
                    <div class="middle4_content">{{text.midpart3.right.content[lang]}}</div>
                </div>
            </div>
            <div class="middle2" data-aos="fade-down" data-aos-duration="500">
                <div class="mid_title2">{{text.midpart2.title[lang]}}</div>
                <div class="mid_content2">{{text.midpart2.content[lang]}}</div>
            </div>
            <div class="middle3" data-aos="fade-down" data-aos-duration="500">
                <img src="../assets/images/consumer_2.jpg" alt="">
            </div>
        </div>
        <Foot/>
        <Nav></Nav>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {wxShare} from '@/js/api.js'
import {consumerText} from '@/js/text.js'
export default {
    components: {
        Nav,
        Foot
    }, 
    data () {
        return {
            text: consumerText
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        showMessage () {
            this.$alert('文章尚在开发中，敬请期待', '提示', {
                confirmButtonText: '确定'
            })
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '耐消品行业'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    }
}
</script>

<style scoped>
.top {
    width: 100%;
    height: 100vh;
    background: linear-gradient(0.01turn, #FF726B, #A62E26);
    position: relative;
    text-align: center;
    margin-bottom: 10%;
}
.top_title_text {
    width: 80vw;
    text-align: center;
    color: #fff;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 4rem;
    font-weight: 500;
    line-height: 1.5;
}
.downtext {
    width: 60%;
    position: absolute;
    bottom: 3rem;
    left: 20%;
    font-size: 1.125rem;
    color: #fff;
}
.icon_down {
    width: 60%;
    position: absolute;
    bottom: 0;
    left: 20%;
    font-size: 2rem;
    color: #fff;
    animation: fade-in-out 1s ease-in-out infinite alternate;
}
@keyframes fade-in-out {
    0% { opacity: 0;}
    100% { opacity: 1;}
}
.subtitle {
    width: 60%;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.5;
    margin: 10% 20%;
}
.middle1 {
    width: 80%;
    margin: 0 10% 10% 10%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.mid_textbox1 {
    width: 34vw;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.mid_title {
    width: 100%;
    margin-bottom: 2vw;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.5;
}
.mid_content {
    width: 100%;
    color: #666;
    font-size: 0.875rem;
    line-height: 1.5;
}
.mid_img1 {
    width: 40vw;
    height: 46vw;
    background: #B6ADB4;
}
.mid_img1 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.middle2 {
    width: 80%;
    margin: 0 10% 10% 10%;
    text-align: left;
    line-height: 1.5;
}
.mid_title2 {
    width: 100%;
    margin-bottom: 2vw;
    font-size: 1.125rem;
    font-weight: bold;
}
.mid_content2 {
    color: #666;
    font-size: 0.875rem;
}
.middle3 {
    width: 80vw;
    margin: 0 10% 10% 10%;
}
.middle3 img {
    width: 100%;
}
.middle4 {
    width: 100%;
    display: flex;
    margin-bottom: 10%;
}
.middle4_item {
    width: 50%;
    height: 30vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 1.5;
}
.middle4_left {
    background: #EB5550;
    color: #fff;
}
.middle4_right {
    background: #F2F2F2;
    color: #666;
}
.middle4_title {
    font-size: 1.125rem;
    font-weight: bold;
    margin-bottom: 10px;
}
.middle4_right .middle4_title {
    color: #EB5550;
}
.middle4_content {
    max-width: 40%;
    font-size: 0.875rem;
}
.bottom {
    width: 100%;
    margin-bottom: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.bottom_item {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    text-align: left;
    line-height: 1.5;
}
.bottom_from {
    position: relative;
    width: 70%;
    font-size: 0.875rem;
    margin-top: 10%;
    margin-bottom: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.from_hover_img {
    width: 100%;
}
.from_hover {
    width: 40%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.bottom_title {
    color: #000;
    text-decoration: none;
    width: 70%;
    height: 3.375rem;
    font-size: 1.125rem;
    font-weight: bold;
    margin-bottom: 10%;
    text-decoration: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.bottom_title:hover {
    cursor: pointer;
    color: #1F40E6;
    text-decoration: underline;
}
.bottom_line {
    border-right: 1px solid #d5d5d5;
}
@media screen and (max-width: 756px) {
    .mid_textbox1 {
        width: 40vw;
    }
    .mid_img1 {
        width: 34vw;
        height: 50vw;
    }
    .middle4 {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10%;
    }
    .middle4_item {
        width: 100%;
        height: 200px;
    }
    .bottom_title {
        height: 5.0625rem;
        font-size: 1.125rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    .middle4_content {
        max-width: 70%;
    }
}
</style>
